export class GreenFlash {
  private element: HTMLDivElement;

  constructor() {
    this.element = document.createElement('div');
    this.element.style.position = 'fixed';
    this.element.style.top = '0';
    this.element.style.left = '0';
    this.element.style.width = '100%';
    this.element.style.height = '100%';
    this.element.style.backgroundColor = 'rgba(0, 255, 0, 0.4)';
    this.element.style.opacity = '0';
    this.element.style.transition = 'opacity 400ms ease-out';
    this.element.style.pointerEvents = 'none';
    this.element.style.zIndex = '1000';
    document.body.appendChild(this.element);
  }

  flash(): void {
    // Force a reflow so the transition triggers even if called rapidly
    this.element.style.transition = 'none';
    this.element.style.opacity = '1';
    // Force reflow
    void this.element.offsetWidth;
    this.element.style.transition = 'opacity 400ms ease-out';
    this.element.style.opacity = '0';
  }

  destroy(): void {
    this.element.remove();
  }
}
